import { Head, router } from "@inertiajs/react"
import { useState } from "react"
import Layout from "../components/Layout"

export default function SignUp({ error, values = {} }) {
  const [username, setUsername] = useState(values.username || "")
  const [email, setEmail] = useState(values.email || "")
  const [password, setPassword] = useState("")
  const [submitting, setSubmitting] = useState(false)

  function handleSubmit(e) {
    e.preventDefault()
    setSubmitting(true)
    router.post("/xyz", {
      user: {
        username,
        email,
        password,
      },
    }, {
      onFinish: () => setSubmitting(false),
    })
  }

  return (
    <Layout>
      <Head title="sign up">
        <meta name="robots" content="noindex,nofollow" />
      </Head>
      <div className="max-w-sm mx-auto pt-8">
        <h1 className="font-serif text-2xl text-cream mb-8">sign up</h1>

        {error && (
          <div className="mb-4 text-sm text-red-400 bg-red-950/30 border border-red-900/40 px-3 py-2 rounded-lg">
            {error}
          </div>
        )}

        <form onSubmit={handleSubmit} className="space-y-4">
          <input
            type="text"
            placeholder="username"
            value={username}
            onChange={e => setUsername(e.target.value)}
            required
            autoFocus
            className="w-full bg-stone-900 border border-stone-700 rounded-lg px-3 py-2.5 text-sm text-stone-100 placeholder-stone-600 focus:outline-none focus:border-stone-500"
          />
          <input
            type="email"
            placeholder="email"
            value={email}
            onChange={e => setEmail(e.target.value)}
            required
            className="w-full bg-stone-900 border border-stone-700 rounded-lg px-3 py-2.5 text-sm text-stone-100 placeholder-stone-600 focus:outline-none focus:border-stone-500"
          />
          <input
            type="password"
            placeholder="password"
            value={password}
            onChange={e => setPassword(e.target.value)}
            required
            className="w-full bg-stone-900 border border-stone-700 rounded-lg px-3 py-2.5 text-sm text-stone-100 placeholder-stone-600 focus:outline-none focus:border-stone-500"
          />
          <button
            type="submit"
            disabled={submitting}
            className="w-full py-2.5 bg-stone-100 hover:bg-white text-stone-900 text-sm font-medium rounded-lg transition-colors disabled:opacity-40"
          >
            {submitting ? "creating account..." : "create account"}
          </button>
        </form>
      </div>
    </Layout>
  )
}
